import React from "react";
import styled from "styled-components";
import { Button, ButtonProps } from "react-bootstrap";

interface LocalButtonProps extends ButtonProps {}

function LocalButton({ children, variant, ...rest }: LocalButtonProps) {
  return (
    <Button variant="success" {...rest}>
      {children}
    </Button>
  );
}

const SuccessButton = styled(LocalButton)`
  color: white;
  &:hover {
    color: white;
  }
`;

export default SuccessButton;
